import { toast } from 'sonner'
import * as Sentry from '@sentry/react'
import { startImpersonationHelper } from '~/client/admin/impersonate.helper'

export type AdminActionType = 'textInput' | 'button'

export interface AdminAction {
  id: string
  type: AdminActionType
  emoji: string
  name: string
  placeholder?: string
  backgroundColor?: string
  gradientColors?: string
  loadingMessage?: (value?: string) => string
  onAction: (value?: string) => void | Promise<void>
}

export const adminActions: AdminAction[] = [
  {
    id: 'impersonate',
    type: 'textInput',
    emoji: '👤',
    name: 'Impersonate User',
    placeholder: 'Enter user email...',
    backgroundColor: 'bg-blue-200 dark:bg-blue-300',
    gradientColors: '#93c5fd, #dbeafe',
    loadingMessage: (value?: string) => `Impersonating user ${value?.trim() || 'unknown'}...`,
    onAction: async (value) => {
      if (!value?.trim()) return
      try {
        await startImpersonationHelper(value.trim())
      } catch (error) {
        toast.error(error instanceof Error ? error.message : 'Failed to impersonate user', {
          position: 'bottom-right',
          richColors: true,
        })
      }
    },
  },
  {
    id: 'break-the-world',
    type: 'button',
    emoji: '💣',
    name: 'Test Sentry Error',
    placeholder: '[Sentry] Enter error message...',
    backgroundColor: 'bg-red-200 dark:bg-red-300',
    gradientColors: '#fca5a5, #fecaca',
    loadingMessage: () => 'Breaking the world...',
    onAction: (value?: string) => {
      console.log('Testing Sentry error tracking...')
      const error = new Error('🚨 Test Sentry Error: ' + value?.trim())
      // Manually capture the error to Sentry
      Sentry.captureException(error, {
        tags: {
          source: 'admin-action',
          action: 'break-the-world',
        },
      })
      // Also throw it so error boundaries can catch it
      throw error
    },
  },
]
